import React from "react";
import { useParams, Link } from "react-router-dom";
import { Toaster } from "sonner";
import { ArrowLeft, Sparkles, Bell } from "lucide-react";
import ArcadeNav from "./ArcadeNav";
import { GAMES, getGameByRoute } from "./games";
import useSEO from "../seo/useSEO";
import { SEO_GAMES } from "../seo/seoData";
import GameSEOContent from "../seo/GameSEOContent";
import ArcadeFooter from "./ArcadeFooter";
import "./arcade.css";

// Polished placeholder for any /games/:slug route whose game isn't built
// yet. Pulls metadata from the games catalog so we automatically get
// matching art accents per game.
export default function ComingSoon({ slug }) {
  const params = useParams();
  const route = `/games/${slug || params.slug || ""}`;
  const game = getGameByRoute(route);
  const gameId = game ? game.id : (slug || params.slug);
  useSEO(SEO_GAMES[gameId] || {});
  // Fallback (route exists but no catalog entry) — render a generic page.
  const data = game || {
    title: "Coming Soon",
    tagline: "We're cooking something spooky.",
    blurb: "This game isn't in the catalog yet. Check back soon!",
    icon: Sparkles,
    accent: "#a569ff",
    accent2: "#7ed957",
    id: "unknown",
  };
  const Icon = data.icon;

  return (
    <div
      className="arcade-page coming-soon-page"
      data-testid={`coming-soon-${data.id}`}
      style={{ "--game-accent": data.accent, "--game-accent-2": data.accent2 }}
    >
      <Toaster position="top-center" theme="dark" />
      <ArcadeNav />

      <div className="arcade-bg" aria-hidden="true">
        <div className="arcade-bg-glow arcade-bg-glow-1" />
        <div className="arcade-bg-glow arcade-bg-glow-2" />
        <div className="arcade-bg-grid" />
      </div>

      <main className="arcade-main">
        <Link to="/" className="coming-back" data-testid="coming-soon-back">
          <ArrowLeft size={16} /> Back to Arcade
        </Link>

        <section className="coming-hero">
          <div className="coming-icon">
            <Icon size={72} strokeWidth={2} />
          </div>
          <span className="game-card-pill coming" data-testid="coming-soon-pill">
            <Sparkles size={12} /> Coming Soon
          </span>
          <h1 className="coming-title">{data.title}</h1>
          <p className="coming-tagline">{data.tagline}</p>
          <p className="coming-blurb">{data.blurb}</p>

          <div className="coming-actions">
            <Link to="/" className="zc-btn primary" data-testid="coming-soon-explore">
              <ArrowLeft size={16} /> Explore other games
            </Link>
          </div>

          <div className="coming-meta">
            <Bell size={12} /> Build it. They will come.
          </div>
        </section>

        {gameId && SEO_GAMES[gameId] && <GameSEOContent gameId={gameId} />}
        <ArcadeFooter />
      </main>
    </div>
  );
}
